import React, { useEffect, useState } from "react";
import { createCrudAccess } from "./redux/userThunk";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../zustand/userStore";

// Convert snake/camelCase to Title Case
const toTitleCase = (str) =>
  str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (s) => s.toUpperCase())
    .trim();

const modules = [
  "events",
  "costsheet",
  "uploadedDocuments",
  "listOfDocuments",
  "docsInProcess",
  "myDocuments",
  "users",
  "questionPaper",
  "schoolModule",
];

const CrudAccess = () => {
  const initialState = modules.reduce((acc, module) => {
    acc[module] = { c: 0, r: 0, u: 0, d: 0 };
    return acc;
  }, {});

  const [userSystemAccess, setUserSystemAccess] = useState(initialState);
  const [selectAll, setSelectAll] = useState(false);
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const { crudAccessData, selectedUserId } = useSelector((state) => state.user);

  console.log("crudAccessData", crudAccessData);

  useEffect(() => {
    if (crudAccessData) {
      //   const fetchedAccess = crudAccessData.crud_access || {};
      const fetchedAccess = crudAccessData.crud_access || {};

      const filledAccess = modules.reduce((acc, module) => {
        acc[module] = fetchedAccess[module] || { c: 0, r: 0, u: 0, d: 0 };
        return acc;
      }, {});

      setUserSystemAccess(filledAccess);
      //   setUserSystemAccess(fetchedAccess);
      const isAllSelected = modules.every((module) =>
        ["c", "r", "u", "d"].every((key) => filledAccess[module][key] === 1)
      );
      setSelectAll(isAllSelected);
    }
  }, [crudAccessData]);

  const handleChange = (module, action) => {
    setUserSystemAccess((prev) => ({
      ...prev,
      [module]: {
        ...prev[module],
        [action]: prev[module][action] === 1 ? 0 : 1,
      },
    }));
  };

  const handleRowSelectAll = (module) => {
    const allSelected = Object.values(userSystemAccess[module]).every(
      (val) => val === 1
    );

    setUserSystemAccess((prev) => ({
      ...prev,
      [module]: {
        c: allSelected ? 0 : 1,
        r: allSelected ? 0 : 1,
        u: allSelected ? 0 : 1,
        d: allSelected ? 0 : 1,
      },
    }));
  };

  const handleSelectAll = () => {
    const newValue = !selectAll;
    const updatedAccess = {};

    modules.forEach((module) => {
      updatedAccess[module] = {
        c: newValue ? 1 : 0,
        r: newValue ? 1 : 0,
        u: newValue ? 1 : 0,
        d: newValue ? 1 : 0,
      };
    });

    setUserSystemAccess(updatedAccess);
    setSelectAll(newValue);
  };

  const handleSubmit = () => {
    const payload = {
      user_id: selectedUserId,
      crud_access: userSystemAccess,
      status: 1,
      created_by: userData.id,
      updated_by: userData.id,
    };
    dispatch(createCrudAccess(payload));
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <div style={{ marginBottom: "10px" }}>
        <label style={{ fontWeight: "bold" }}>
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ marginRight: "8px" }}
          />
          Select All Permissions
        </label>
      </div>

      {modules.map((module) => (
        <div
          key={module}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "10px",
          }}
        >
          <div style={{ fontWeight: "bold", width: "200px" }}>
            {toTitleCase(module)}
          </div>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            {[
              { key: "c", label: "Create" },
              { key: "r", label: "Read" },
              { key: "u", label: "Update" },
              { key: "d", label: "Delete" },
            ].map(({ key, label }) => (
              <label
                key={key}
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  type="checkbox"
                  checked={userSystemAccess[module][key] === 1}
                  onChange={() => handleChange(module, key)}
                  style={{ marginRight: "6px" }}
                />
                {label}
              </label>
            ))}
            <label style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                checked={Object.values(userSystemAccess[module]).every(
                  (val) => val === 1
                )}
                onChange={() => handleRowSelectAll(module)}
                style={{ marginRight: "6px" }}
              />
              All
            </label>
          </div>
        </div>
      ))}

      <button
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={handleSubmit}
      >
        Submit
      </button>
    </div>
  );
};

export default CrudAccess;
